// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPsPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.502 3.154a1.293 1.293 0 0 0-.978.44 1.467 1.467 0 0 0-.39 1.076 17.976 17.976 0 0 0 2.821 7.91 17.754 17.754 0 0 0 5.486 5.485 18.103 18.103 0 0 0 7.886 2.784h.15c.34-.004.666-.125.926-.343a1.345 1.345 0 0 0 .44-1.028v-2.836a1.419 1.419 0 0 0-1.173-1.416 13.16 13.16 0 0 1-2.743-.685 1.296 1.296 0 0 0-.47-.086 1.55 1.55 0 0 0-.984.387L14.3 16.015a.517.517 0 0 1-.366.147.486.486 0 0 1-.22-.048 15.155 15.155 0 0 1-5.828-5.828.456.456 0 0 1 .085-.583l1.173-1.166a1.371 1.371 0 0 0 .295-1.467 13.163 13.163 0 0 1-.686-2.743 1.46 1.46 0 0 0-1.416-1.173zm2.842-.685a2.136 2.136 0 0 1 2.088 1.714.177.177 0 0 0 0 .038c.12.883.335 1.75.641 2.588a2.057 2.057 0 0 1-.442 2.205l-1.08 1.08a14.479 14.479 0 0 0 5.335 5.335l1.09-1.08.03-.031a2.24 2.24 0 0 1 1.451-.549c.244-.001.486.044.713.134a12.48 12.48 0 0 0 2.585.645 2.102 2.102 0 0 1 1.763 2.094v2.822a2.003 2.003 0 0 1-.686 1.553 2.14 2.14 0 0 1-1.372.511 1.506 1.506 0 0 1-.222 0 18.75 18.75 0 0 1-8.16-2.883A18.538 18.538 0 0 1 5.39 12.97a18.654 18.654 0 0 1-2.942-8.228.506.506 0 0 1 0-.072 2.146 2.146 0 0 1 1.241-2.028c.256-.114.533-.173.813-.173h2.835z"
    />
  </svg>
);
export default SvgPsPhone;
